{
  "(optional)": "(optional)",
  "(required)": "(erforderlich)"
}
